import { c as _c } from "react/compiler-runtime";
import { Box, Button, Heading, HStack, Text, VStack } from '@chakra-ui/react';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import NextLink from 'next/link';
import { LuHouse, LuRefreshCw, LuTriangleAlert } from 'react-icons/lu';
export type ErrorFallbackProps = {
  /** Visual density: full page vs compact section */
  variant?: 'page' | 'section';
  title?: string;
  description?: string;
  error?: Error | null;
  eventId?: string | null;
  onReset?: () => void;
  showHomeLink?: boolean;
};
const isDev = process.env.NODE_ENV !== 'production';
export function ErrorFallback(t0) {
  const $ = _c(33);
  const {
    variant: t1,
    title: t2,
    description: t3,
    error,
    eventId,
    onReset,
    showHomeLink: t4
  } = t0;
  const variant = t1 === undefined ? "page" : t1;
  const title = t2 === undefined ? "Something went wrong" : t2;
  const description = t3 === undefined ? "We've been notified and are looking into it." : t3;
  const showHomeLink = t4 === undefined ? true : t4;
  const isPage = variant === "page";
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScoSiteNavBar conversionMode={true} />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const t6 = isPage ? "50vh" : undefined;
  const t7 = isPage ? "12vh" : 8;
  const t8 = isPage ? 6 : 4;
  const t9 = isPage ? "3xl" : "2xl";
  let t10;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LuTriangleAlert />;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  let t11;
  if ($[2] !== t9) {
    t11 = <Box aria-hidden={true} color="fg.muted" display="flex" fontSize={t9} justifyContent="center">{t10}</Box>;
    $[2] = t9;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const t12 = isPage ? "lg" : "md";
  let t13;
  if ($[4] !== t12 || $[5] !== title) {
    t13 = <Heading as="h1" size={t12}>{title}</Heading>;
    $[4] = t12;
    $[5] = title;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  const t14 = isPage ? "md" : "sm";
  let t15;
  if ($[7] !== description || $[8] !== t14) {
    t15 = <Text color="fg.muted" textStyle={t14}>{description}</Text>;
    $[7] = description;
    $[8] = t14;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  let t16;
  if ($[10] !== t13 || $[11] !== t15) {
    t16 = <VStack gap={2}>{t13}{t15}</VStack>;
    $[10] = t13;
    $[11] = t15;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== onReset) {
    t17 = onReset ? <Button onClick={onReset}><LuRefreshCw />Try again</Button> : null;
    $[13] = onReset;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] !== showHomeLink) {
    t18 = showHomeLink ? <Button asChild={true} variant="outline"><NextLink href="/"><LuHouse />Back to home</NextLink></Button> : null;
    $[15] = showHomeLink;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] !== t17 || $[18] !== t18) {
    t19 = <HStack flexWrap="wrap" gap={3} justify="center">{t17}{t18}</HStack>;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== error || $[21] !== eventId) {
    t20 = isDev && error || eventId ? <Box bg="bg.muted" borderColor="border" borderRadius="md" borderWidth="1px" padding={3} textAlign="left" width="full">{isDev && error ? <Text as="pre" color="fg.muted" fontFamily="mono" fontSize="xs" whiteSpace="pre-wrap" wordBreak="break-word">{error.name}: {error.message}</Text> : null}{eventId ? <Text color="fg.subtle" fontSize="xs" marginTop={isDev && error ? 2 : 0}>Reference: {eventId}</Text> : null}</Box> : null;
    $[20] = error;
    $[21] = eventId;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] !== t11 || $[24] !== t16 || $[25] !== t19 || $[26] !== t20 || $[27] !== t8) {
    t21 = <VStack gap={t8} marginX="auto" maxWidth="lg">{t11}{t16}{t19}{t20}</VStack>;
    $[23] = t11;
    $[24] = t16;
    $[25] = t19;
    $[26] = t20;
    $[27] = t8;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t21 || $[30] !== t6 || $[31] !== t7) {
    t22 = <>{t5}<Box as="section" minHeight={t6} paddingX={4} paddingY={t7} textAlign="center" width="full">{t21}</Box></>;
    $[29] = t21;
    $[30] = t6;
    $[31] = t7;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  return t22;
}